/**
 * @module Theme
 */

import { Component, Input } from '@angular/core';
import { ItemColor } from '@functions/item.functions';
import { ThemeOptionsClass } from '@class/themeOptions.class';
import { ChartType } from '@models/chart.model';
import { ThemeOptionType } from '@models/themeStudio.model';

@Component({
  selector: 'app-theme-option-axes-grid-lines-draw-border',
  templateUrl: './theme-option-axes-grid-lines-draw-border.component.html',
  styleUrls: ['./theme-option-axes-grid-lines-draw-border.component.css']
})
export class ThemeOptionAxesGridLinesDrawBorderComponent {

  @Input() themeOptions: ThemeOptionsClass;
  @Input() axesIndex: number;
  @Input() axesXY: 'x' | 'y';

  color = ItemColor('themes');
  optionType: ThemeOptionType = 'axes_gridLines_drawBorder';
  showDetails: boolean;

  constructor() {}

  receiveShowDetails(showDetails: boolean) {
    this.showDetails = showDetails;
  }

  receiveValue(value: boolean, type?: ChartType) {
    this.themeOptions.setAxes(this.optionType, value, this.axesXY, this.axesIndex, type ? [type] : undefined);
  }

}
